






















import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import AbstractDatatable from '@/zenky/datatables/AbstractDatatable';
import DatatableComponent from '@/components/datatables/Datatable.vue';
import axios from '@/zenky/api/Http';
import axiosModule from 'axios';
import PaginatedResponse from '@/zenky/api/responses/PaginatedResponse';
import { Route } from 'vue-router';

@Component
export default class ResourcesIndexPage extends Vue {
  @Prop({ type: Object, required: true }) datatable!: AbstractDatatable;
  @Prop({ type: Object, required: true }) filterQuery!: Route['query'];
  items: any[] | null = null; // `null` means that they're not loaded.
  neverBeforeLoadedItems: boolean = true;
  requestCancelTokenSource: ReturnType<typeof axiosModule['CancelToken']['source']> | null = null;
  totalPages: number = 1;

  created() {
    this.loadItems();
  }

  // Keep in mind that datatable can also display both loading and no-items messages.
  get drawNoItemsPlaceholder(): boolean {
    return this.$slots.noItemsPlaceholder !== undefined
      && (this.items !== null && this.items.length === 0)
      && Object.keys(this.filterQuery).length === 0;
  }
  get drawLoadingPlaceholder(): boolean {
    return this.neverBeforeLoadedItems && this.items === null;
  }

  get loading(): boolean {
    return this.requestCancelTokenSource !== null;
  }

  async loadItems() {
    const deliberateCancelMessage = 'noMoreNeeded';
    if (this.loading) {
      this.requestCancelTokenSource!.cancel(deliberateCancelMessage);
    }
    this.requestCancelTokenSource = axiosModule.CancelToken.source();

    this.items = null;
    this.totalPages = 1;

    try {
      const request = axios.get(this.datatable.baseApiUrl(), {
        params: this.filterQuery,
        cancelToken: this.requestCancelTokenSource.token,
      });
      const data = (await request).data as PaginatedResponse<any>;
      this.items = data.data;
      this.totalPages = data.meta.pagination.total_pages;
      this.neverBeforeLoadedItems = false;
    } catch (err) {
      if (err.message !== deliberateCancelMessage) {
        throw err;
      }
    } finally {
      this.requestCancelTokenSource = null;
    }
  }

  @Watch('filterQuery')
  onRouteChange(newQuery: this['filterQuery'], oldQuery: this['filterQuery']) {
    if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
      this.loadItems();
    }
  }
  @Watch('datatable')
  onDatatableUrlChange(newDatatable: AbstractDatatable, oldDatatable: AbstractDatatable) {
    if (newDatatable.baseApiUrl() !== oldDatatable.baseApiUrl()) {
      this.neverBeforeLoadedItems = true;
      this.loadItems();
    }
  }

  // protected actionsGenerator(data: any) {
  //   const actions = this.datatable.actions(data);

  //   return actions.map((action: any) => {
  //     if (typeof action.url !== 'undefined' && !!action.url) {
  //       return action;
  //     } else if (typeof action.route !== 'undefined' && !!action.route) {
  //       return {
  //         ...action,
  //         url: this.$router.resolve(action.route).href,
  //       };
  //     }

  //     return action;
  //   });
  // }
}
